import React, { useEffect } from 'react';
import { Box, Alert } from '@chakra-ui/react';
import { CloseButton } from "../ui/close-button";
import { useDispatch, useSelector } from 'react-redux';
import { hideAlert } from '../../store/alertSlice';

const AppAlert = () => {
  const { alerts } = useSelector((state) => state.alert);

  return (
    <Box position="fixed" bottom="4" right="4" zIndex={100000} display="flex" flexDirection="column-reverse" gap={2}>
      {alerts.map((alert) => (
        <AlertBox
          key={alert.id}
          id={alert.id}
          status={alert.type}
          description={alert.message}
          timeout={alert.timeout}
        />
      ))}
    </Box>
  );
};

const AlertBox = (props) => {
  const { id, status = "success", size = "md", title = null, description = null, timeout } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(hideAlert({ id }));
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout, dispatch, id]);

  return (
    <Alert.Root status={status} size={size} variant="solid">
      <Alert.Indicator />
      <Alert.Content>
        {title && <Alert.Title>{title}</Alert.Title>}
        {description && <Alert.Description>{description}</Alert.Description>}
      </Alert.Content>
      <CloseButton pos="relative" top="-2" insetEnd="-2" onClick={() => dispatch(hideAlert({ id }))} />
    </Alert.Root>
  );
};

export { AppAlert, AlertBox };